<input type="range" 
	[attr.min]="min" 
	[attr.max]="max" 
	[attr.step]="step"
	[(ngModel)]="value"
	class="custom-range"
	[ngClass]="{'range-vertical': vertical}"
	name="valueRange"
	id="valueRange">
<div class="label-container">
	<span class="label label-default">{{value}}</span>
</div>